export const loadingClass = (
  loading: boolean,
  prefix: string,
): string | undefined => {
  if (loading) {
    return `${prefix}btn--loading`;
  }

  return undefined;
};
